import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var SplitOrderIA = function SplitOrderIA(_ref) {
  var context = _ref.context;
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "B7GCRh",
    defaultMessage: [{
      "type": 0,
      "value": "Dividir uma encomenda é útil quando precisa de ajustar os detalhes de alguns produtos sem os colocar em espera para uma nova data. Para dividir uma encomenda:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "doQrD2",
    defaultMessage: [{
      "type": 0,
      "value": "1. Visite a "
    }, {
      "children": [{
        "type": 0,
        "value": "página de informações da encomenda"
      }],
      "type": 8,
      "value": "OrderLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      OrderLinkFormatting: function OrderLinkFormatting(chunks) {
        var _context$brandOrder, _context$brandOrder$b;
        return _OrderLinkFormatting(chunks, (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "9rbh3V",
    defaultMessage: [{
      "type": 0,
      "value": "2. Nessa página, selecione a opção "
    }, {
      "children": [{
        "type": 0,
        "value": "Dividir"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " (habitualmente, pode encontrá-la à direita)."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "+ArNhy",
    defaultMessage: [{
      "type": 0,
      "value": "3. São apresentados todos os produtos na encomenda e a respetiva quantidade. Especifique as quantidades que pretende mover para uma nova encomenda."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "zCnJLL",
    defaultMessage: [{
      "type": 0,
      "value": "4. Após escolher conforme necessário, selecione "
    }, {
      "children": [{
        "type": 0,
        "value": "Criar nova encomenda"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "GWvkwO",
    defaultMessage: [{
      "type": 0,
      "value": "Ambas as encomendas têm o mesmo endereço de envio e data de envio prevista, mas a nova encomenda tem um número de encomenda à marca exclusivo."
    }]
  })));
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};